const styles = theme => ({
  containerWrapperEquipFilters: {
    minHeight: '60px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.gray[5]}`,
    alignItems: 'center',
    paddingBottom: '12px',
  },
  subtitle: {
    fontSize: '12px',
    fontWeight: 500,
  },
  wrapperEquipFiltersActions: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    justifyContent: 'space-between',
    width: '100%',
  },
  actionsButtons: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    gap: '10px',
  },
  switchContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '34px',
    gap: '4px',
  },
  icon: {
    height: '20px',
    width: '20px',
  },
  fullScreenButton: {
    border: `1px solid ${theme.palette.gray[40]}`,
    boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.15)',
    color: theme.palette.gray[40],
  },
});

export default styles;
